export default "__VITE_ASSET__EXR$OUKy__"